import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/teachers/teachersCollageCopy.webp'


const _withScopeId = n => (_pushScopeId("data-v-391a71a3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "theTeachers" }
const _hoisted_2 = { class: "theTeachers__images" }
const _hoisted_3 = {
  key: 0,
  class: "images__carousel"
}
const _hoisted_4 = { class: "carousel__slide" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "images__collage"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Teacher picture"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"theTeachers__description\" data-v-391a71a3><h3 id=\"descriptionTitle\" class=\"description__title\" data-v-391a71a3>lxs profes</h3><article class=\"description__information\" data-v-391a71a3><p class=\"information__text\" data-v-391a71a3>Lxs profes de Chatterbox somos especiales. No solo por las aptitudes de enseñar inglés, sino por nuestra creatividad, dedicación y energía.</p><p class=\"information__text\" data-v-391a71a3>Somos de todas partes del mundo, pero compartimos las ganas de sacar lo mejor de cada alumnx.</p><p class=\"information__text\" data-v-391a71a3>Todos poseemos:</p><ul class=\"informationlist\" data-v-391a71a3><li class=\"list__item\" data-v-391a71a3>inglés nativo</li><li class=\"list__item\" data-v-391a71a3>conocimiento profundo</li><li class=\"list__item\" data-v-391a71a3>certificación y experiencia</li><li class=\"list__item\" data-v-391a71a3>creatividad y entusiasmo</li><li class=\"list__item\" data-v-391a71a3>paciencia y buen escucha al alumno</li><li class=\"list__item\" data-v-391a71a3>la mejor onda, siempre</li></ul></article></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TeachersSlide = _resolveComponent("TeachersSlide")!
  const _component_TeacherCarousel = _resolveComponent("TeacherCarousel")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.mobileSize)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_TeacherCarousel, {
              navigation: true,
              timeout: 3000,
              class: "carousel__carousel",
              id: "teacherCarousel"
            }, {
              default: _withCtx(({currentSlide}) => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carouselSlides, (imageWebp, index) => {
                  return (_openBlock(), _createBlock(_component_TeachersSlide, { key: index }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("div", _hoisted_4, [
                        _createElementVNode("img", {
                          src: require(`../../assets/teachers/${imageWebp}.webp`),
                          alt: "Teacher picture"
                        }, null, 8, _hoisted_5)
                      ], 512), [
                        [_vShow, currentSlide === index]
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
    ]),
    _hoisted_9
  ]))
}